export default __webpack_public_path__ + "ab7fb4e5847a5202809d476b4b31ec29.svg";